import CoverPhotoButton from './CoverPhotoButtonContainer';

export default CoverPhotoButton;
